import InfoBox from "./InfoBox";
import type { InfoBoxAdapterProps } from "./InfoBox.d";

export { InfoBox };
export type { InfoBoxAdapterProps };
